// OCR Test Suite — API endpoint paths (PLAN-ocr-test-suite.md §5, §7).
// Relative to AxiosInstance baseURL (REACT_APP_API_URL, which already ends /api/v1/).
// Mirrors the Stage-2 route group in
// backend/src/testSuite/server-routes/ocrTestSuite.routes.ts (path '/ocr-test-suite/'),
// mounted on the admin router only when ENABLE_OCR_TEST_SUITE === 'true'.

const BASE = "ocr-test-suite";

// ── test cases ──
export const LIST_CASES = `${BASE}/cases`;
export const CREATE_CASE = `${BASE}/cases`;
export const UPDATE_CASE = `${BASE}/cases`; // + `/${id}`

// ── fixture upload ──
export const PRESIGN_FIXTURE_UPLOAD = `${BASE}/fixtures/presigned-upload-url`;

// ── runs ──
export const RUN = `${BASE}/run`;
export const LIST_RUNS = `${BASE}/runs`;
export const GET_RUN = `${BASE}/runs`; // + `/${id}`
export const APPROVE_RUN = `${BASE}/runs`; // + `/${id}/approve`
export const DIFF_RUNS = `${BASE}/runs/diff`;

// ── test companies ──
export const LIST_COMPANIES = `${BASE}/companies`;
export const CREATE_COMPANY = `${BASE}/companies`;
export const UPDATE_COMPANY = `${BASE}/companies`; // + `/${id}`
export const SEARCH_COMPANIES = `${BASE}/companies/search`;
